import { apiService } from '@/shared/services/apiServices';
import type {
  GetProfileResponse,
  UpdateProfilePayload,
} from '../types/userProfileTypes';
import userProfileEndpoints from './userProfileEndpoints';

const PROFILE_ENDPOINT = userProfileEndpoints.VIEW_PROFILE;

export interface GetProfileResult {
  success: boolean;
  data?: GetProfileResponse;
  error?: string;
}

export interface UpdateProfileResult {
  success: boolean;
  data?: GetProfileResponse;
  error?: string;
}

const extractErrorMessage = (errorData: unknown): string => {
  if (!errorData) {
    return 'Nie udało się załadować profilu. Spróbuj ponownie.';
  }
  if (typeof errorData === 'string') {
    return errorData;
  }
  if (typeof errorData === 'object') {
    const err = errorData as { message?: string; error?: string };
    return (
      err.message ||
      err.error ||
      'Nie udało się załadować profilu. Spróbuj ponownie.'
    );
  }
  return 'Nie udało się załadować profilu. Spróbuj ponownie.';
};

export const getMyProfile = async (): Promise<GetProfileResult> => {
  try {
    const result = await apiService.getAPI(PROFILE_ENDPOINT);
    if (!result.error) {
      return { success: true, data: result.data as GetProfileResponse };
    }
    if (result.isNetworkError) {
      return { success: false, error: 'Błąd sieci. Sprawdź połączenie.' };
    }
    return { success: false, error: extractErrorMessage(result.data) };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Wystąpił nieoczekiwany błąd.',
    };
  }
};

export const updateMyProfile = async (
  data: UpdateProfilePayload
): Promise<UpdateProfileResult> => {
  try {
    const result = await apiService.patchAPI(PROFILE_ENDPOINT, data);
    if (!result.error) {
      return { success: true, data: result.data as GetProfileResponse };
    }
    if (result.isNetworkError) {
      return { success: false, error: 'Błąd sieci. Sprawdź połączenie.' };
    }
    return { success: false, error: extractErrorMessage(result.data) };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Wystąpił nieoczekiwany błąd.',
    };
  }
};
